<template>
  <div class="user-center">
    <div class="top-banner-wrapper">
      <div class="top-banner">
        <div class="top-banner-left">
          <div style="width: 70px; height: 70px">
            <img src="@/assets/image/logo.jpg" style="width: 100%; height: 100%" />
          </div>
          <div class="top-banner-title">{{ currentMenuTitle }}</div>
        </div>
        <div class="top-banner-right" @click="goHome">
          <img class="top-banner-home-icon" src="@/assets/image/shouye.png" />
          <div class="top-banner-home-text">首页</div>
        </div>
      </div>
    </div>
    <div class="user-center-body">
      <div class="sidebar">
        <div v-for="item in menuList" :key="item.path" class="menu-item" :class="{ active: activeMenu === item.path }" @click="goTo(item.path)">
          <img class="menu-icon" :src="item.icon" v-if="activeMenu !== item.path" />
          <img class="menu-icon" :src="item.iconActive" v-else />
          <span class="menu-title">{{ item.title }}</span>
        </div>
      </div>
      <div class="main-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { getMyUserInfo } from "@/api";
export default {
  name: "UserCenter",
  data() {
    return {
      menuList: [
        {
          title: "信息查看与管理",
          path: "/user-center/info-manage",
          icon: require("@/assets/image/menuIcon5.png"),
          iconActive: require("@/assets/image/menuIcon55.png"),
        },
        {
          title: "个人信息",
          path: "/user-center/personal-info",
          icon: require("@/assets/image/menuIcon6.png"),
          iconActive: require("@/assets/image/menuIcon66.png"),
        },
        {
          title: "用户协议",
          path: "/user-center/user-agreement",
          icon: require("@/assets/image/menuIcon2.png"),
          iconActive: require("@/assets/image/menuIcon22.png"),
        },
        {
          title: "隐私协议",
          path: "/user-center/privacy-agreement",
          icon: require("@/assets/image/menuIcon1.png"),
          iconActive: require("@/assets/image/menuIcon11.png"),
        },
        {
          title: "投诉建议",
          path: "/user-center/complaint-suggestion",
          icon: require("@/assets/image/menuIcon7.png"),
          iconActive: require("@/assets/image/menuIcon77.png"),
        },
      ],
      menuTit: [
        { title: "信息查看与管理", path: "/user-center/info-manage" },
        { title: "个人信息", path: "/user-center/personal-info" },
        { title: "用户协议", path: "/user-center/user-agreement" },
        { title: "隐私协议", path: "/user-center/privacy-agreement" },
        { title: "投诉建议", path: "/user-center/complaint-suggestion" },
        { title: "申请详情", path: "/user-center/requirement-details" },
      ],
      userInfo: {
        userId: null,
        headPortrait: "",
        userName: "",
        enterpriseName: "",
        relationName: "",
        relationPhone: "",
        postName: "",
        role: "",
        wxNumber: "",
        mail: "",
        address: "",
        businessLicense: "",
      },
    };
  },
  computed: {
    activeMenu() {
      return this.$route.path;
    },
    currentMenuTitle() {
      const match = this.menuTit.find((item) => item.path === this.$route.path);
      return match ? match.title : "个人设置";
    },
  },
  mounted() {
    this.fetchUserInfo();
  },
  methods: {
    async fetchUserInfo() {
      this.loading = true;
      try {
        const res = await getMyUserInfo();
        if (res.code === 200 && res.data) {
          this.userInfo = { ...this.userInfo, ...res.data };
        }
      } catch (error) {
        this.$message.error("获取用户信息失败");
      } finally {
        this.loading = false;
      }
    },

    goTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    goHome() {
      this.$router.push("/home");
    },
  },
};
</script>

<style scoped>
.user-center {
  background: #f0f4fa;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 20px;
}

.sidebar {
  width: 230px;
  background: #ffffff;
  position: sticky;
  top: 0;
  border-radius: 20px;
  padding: 4px 0;
  flex-shrink: 0;
  align-self: flex-start;
}

.menu-item {
  display: flex;
  align-items: center;
  height: 52px;
  padding: 0 0 0 28px;
  cursor: pointer;
  transition: all 0.3s;
  margin: 4px 12px;
  border-radius: 10px;
}

.menu-item:hover {
  background: #f0f5ff;
}

.menu-item.active {
  background: #ebf2ff;
  color: #ffffff;
  font-weight: 500;
}

.menu-item.active .menu-title {
  color: #1869ff;
}

.menu-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  object-fit: contain;
}

.menu-title {
  font-size: 18px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  color: #333333;
}

.main-content {
  flex: 1;
  margin-left: 26px;
}
.top-banner-wrapper {
  flex-shrink: 0;
  background: #fff;
}

.top-banner {
  height: 70px;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  font-size: 28px;
  color: #333333;
}

.top-banner-left {
  display: flex;
  align-items: center;
}

.top-banner-title {
  margin-left: 33px;
}

.top-banner-right {
  display: flex;
  cursor: pointer;
  align-items: center;
}

.top-banner-home-icon {
  width: 24px;
  height: 24px;
  align-items: center;
}

.top-banner-home-text {
  font-size: 22px;
  font-weight: 400;
  margin-left: 10px;
}

.user-center-body {
  display: flex;
  flex: 1;
  overflow-y: auto;
  max-width: 1200px;
  width: 100%;
  margin: 10px auto 0 auto;
}
</style>
